import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 15.9998,
			cy: 16.0013,
			r: 13.8333,
			stroke: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.6665,
			y: 13.332,
			width: 2.5,
			height: 10.6667,
			fill: "#162395"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14.6665,
			y: 8,
			width: 2.67,
			height: 2.66667,
			fill: "#162395"
		})
	]
});
export default SvgInfoCircleFilled;
